import { Tag as V3Tag, TagProps } from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './tag.module.scss';

export const Tag = ({
  classNames,
  selected,
  onDark,
  size = 'medium',
  ...props
}: TagProps) => {
  const classes = classnames(
    [
      styles.tagTokens,
      styles.tag,
      styles[size],
      {
        [`${styles.selected}`]: selected,
        [`${styles.onDark}`]: onDark,
      },
    ],
    classNames
  );

  return (
    <V3Tag
      classNames={[classes]}
      size={size}
      selected={selected}
      onDark={onDark}
      {...props}
    />
  );
};
